"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlgoliaCustomData = void 0;
const getAlgoliaCustomData = (key, userData) => {
    if (!userData?.length) {
        return undefined;
    }
    const match = userData.find(customData => key in customData);
    return match ? match[key] : undefined;
};
exports.getAlgoliaCustomData = getAlgoliaCustomData;
//# sourceMappingURL=getAlgoliaCustomData.js.map